import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { nodeURL } from '../configUrl';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

const AdminPanel = () => {
  const [pendingUsers, setPendingUsers] = useState([]);


  useEffect(() => {
    fetchPendingUsers();
  }, []);

  const fetchPendingUsers = async () => {
    try {
      const response = await axios.get(`${nodeURL}/admin_onay_bekleyenler`); // GET listesi için backend'e endpoint lazım
      console.log(response.data,"responsedata");
      
      setPendingUsers(response.data);
    } catch (err) {
      console.error('Kullanıcılar alınamadı:', err);
    }
  };

  const handleApprove = async (email) => {
    try {
      const response = await axios.post(`${nodeURL}/admin_onay`, { email });
      toast.success(response.data.msg || 'Kayıt başarılı!', {
        position: 'top-right',
        autoClose: 7000,
      });
      fetchPendingUsers(); // Listeyi güncelle
    } catch (err) {
      console.error('Onaylama hatası:', err);
      toast.error(err.response?.data?.msg || 'Kayıt başarısız!', {
        position: 'top-right',
        autoClose: 7000,
      });
    }
  };

  const handleReject = (email) => {
    Swal.fire({
      title: 'Emin misiniz?',
      text: `${email} başvurusu reddedilecek!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Evet, reddet',
      cancelButtonText: 'Vazgeç',
    }).then((result) => {
      if (!result.isConfirmed) return;

      axios
        .post(`${nodeURL}/admin_onay_reddet`, { email })
        .then((response) => {
          toast.success(response.data.msg || 'Başvuru reddedildi!', {
            position: 'top-right',
            autoClose: 7000,
          });
          fetchPendingUsers();
        })
        .catch((err) => {
          console.error('Reddetme hatası:', err);
          toast.error(err.response?.data?.msg || 'Reddetme başarısız!', {
            position: 'top-right',
            autoClose: 7000,
          });
        });
    });
  };

  return (
<div
style={{
  background: "rgba(255, 255, 255, 0.2)",
  borderRadius: "15px",
  padding: "20px",
  backdropFilter: "blur(10px)",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
}}
>

  <>

  {pendingUsers.length === 0 ? (
         <h2
         style={{
      
           marginRight: '20px',
           flexShrink: 0,
           whiteSpace: 'nowrap',
           textAlign:'center'
         }}
       >
        Onay Bekleyen Kullanıcı Yok
       </h2>
       ) : (

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ background: "#f4f4f4", textAlign: "left" }}>
          <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
           Kullanıcı Adı
          </th>
          <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
            E-mail
          </th>
          <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
            İşlem
          </th>
        </tr>
      </thead>
      <tbody>
            {pendingUsers.map((user) => (
              <tr key={user.email}>
                <td className="p-2 border">{user.username}</td>
                <td className="p-2 border">{user.email}</td>
                <td className="p-2 border">
                  <button
                  style={{color:'white'}}
                    className="btn btn-sm bg-success"
                    onClick={() => handleApprove(user.email)}
                  >
                    Onayla
                  </button>
                  <button
                     style={{color:'white'}}
                    className="btn btn-sm bg-danger ms-3"
                    onClick={() => handleReject(user.email)}
                  >
                    Reddet
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
    </table>
       )}
    
   
  </>

</div>
  );
};

export default AdminPanel;
